import * as CryptoJS from 'crypto-js'
import AuthService from './auth.service'
import { store } from '../store'
import http from '../api/api'
import config from '../api/constants'

const getAllAccounts = async () => {
  try {
    const { app } = store.getState()
    const reqParams = {
      accountType: 'S',
      brnCode: app.profile.branchCode,
      requestId: 'ACCOUNTSUMMARY',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAllBanks = async () => {
  try {
    const reqParams = {
      requestId: 'GETALLBANKS',
    }
    const response = await http.post(config.apiRoute.GET_ALL_BANKS, reqParams)
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

const getQuickPayTerms = async () => {
  try {
    const reqParams = {
      module: 'QP',
      customerId: '0000000',
      requestId: 'OFFERS',
      userName: 'DEFAULT',
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_TERMS, reqParams)
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

const getTransferType = async () => {
  try {
    const reqParams = {
      requestId: 'GETTRANSFERTYPES',
    }
    const response = await http.post(config.apiRoute.GET_TRANSFER_TYPES, reqParams)
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

export const decryptQRCode = async (text) => {
  text = text.replace(/\r?\n|\r/g, '')
  const response = AuthService.decryptAES(text)
  return response.toString(CryptoJS.enc.Utf8)
}

const fundTransferVerify = async (reqParams) => {
  try {
    const response = await http.post(config.apiRoute.FUND_TRANSFER_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const fundTransferConfirm = async (reqParams) => {
  try {
    const response = await http.post(config.apiRoute.FUND_TRANSFER_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const QuickPayService = {
  getAllAccounts,
  getAllBanks,
  getQuickPayTerms,
  getTransferType,
  fundTransferVerify,
  fundTransferConfirm
}

export default QuickPayService